import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getContacts, updateContact, deleteContact, bulkDeleteContacts, ContactCreateInput } from '../api/contacts';
import { ContactsListParams } from '../types';

export function useContacts(params: ContactsListParams = {}) {
  return useQuery({
    queryKey: ['contacts', params],
    queryFn: () => getContacts(params),
    staleTime: 0,
    gcTime: 30_000,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
}

export function useUpdateContact() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: Partial<ContactCreateInput> }) =>
      updateContact(id, input),
    onSuccess: async () => {
      // WICHTIG: await hier — mutateAsync resolved erst wenn Daten frisch sind.
      // Ohne await würde die Liste noch alte Daten zeigen wenn das Modal schließt.
      await queryClient.invalidateQueries({ queryKey: ['contacts'] });
      // Restliche Caches parallel im Hintergrund invalidieren
      void queryClient.invalidateQueries({ queryKey: ['contact'] });
      void queryClient.invalidateQueries({ queryKey: ['company'] });
      void queryClient.invalidateQueries({ queryKey: ['companies'] });
    },
  });
}

export function useDeleteContact() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteContact,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['contacts'] });
      void queryClient.invalidateQueries({ queryKey: ['companies'] });
    },
  });
}

export function useBulkDeleteContacts() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: bulkDeleteContacts,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['contacts'] });
      void queryClient.invalidateQueries({ queryKey: ['companies'] });
    },
  });
}
